import React from 'react';

import { Grid } from 'ui';
import RegionGridItem, { Region } from 'components/wineries/RegionGridItem';

export interface Props {
  regions: Region[];
}

const RegionGrid: React.FC<Props> = ({ regions }) => {
  return (
    <Grid container spacing={3}>
      {regions.map((region) => (
        <RegionGridItem region={region} key={region.region} />
      ))}
    </Grid>
  );
};

export default RegionGrid;
